<template>
    <div class="container">
        <!--<header class="page-header" >
            <a class="page-header__logo" href="/"><img src="assets/images/logo.svg" alt=""></a>
        </header>-->

        <router-view/>

        <div class="bottom-menu">
            <div v-if="$route.path == '/catalog'" class="bottom-menu__item _current">
                <span class="bottom-menu__icon-wrap">
                    <svg class="svg-icon-catalog svg-icon" width="25" height="25"><use xlink:href="#catalog"></use></svg>
                </span>
                Каталог
            </div>
            <router-link class="bottom-menu__item"  v-else to="/catalog">
                <span class="bottom-menu__icon-wrap">
                    <svg class="svg-icon-catalog svg-icon" width="25" height="25"><use xlink:href="#catalog"></use></svg>
                </span>
                Каталог
            </router-link>

            <div v-if="$route.path == '/orders'" class="bottom-menu__item _current">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-order svg-icon" width="20" height="25"><use xlink:href="#order"></use></svg></span>
                Заказы<span  class="bottom-menu__count">{{orderCount}}</span>
            </div>
            <router-link class="bottom-menu__item"  v-else to="/orders">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-order svg-icon" width="20" height="25"><use xlink:href="#order"></use></svg></span>
                Заказы<span  class="bottom-menu__count">{{orderCount}}</span>
            </router-link>

            <div v-if="$route.path == '/basket'" class="bottom-menu__item _current">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-cart2 svg-icon" width="25" height="22"><use xlink:href="#cart2"></use></svg></span>
                Корзина<span  class="bottom-menu__count">{{basketCount}}</span>
            </div>
            <router-link class="bottom-menu__item" v-else to="/basket">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-cart2 svg-icon" width="25" height="22"><use xlink:href="#cart2"></use></svg></span>
                Корзина<span class="bottom-menu__count">{{basketCount}}</span>
            </router-link>

            <div v-if="$route.path == '/auth' && user.id <= 0" class="bottom-menu__item _current">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-enter2 svg-icon" width="24" height="26"><use xlink:href="#enter2"></use></svg></span>
                Вход
            </div>
            <router-link v-else-if="user.id <= 0" class="bottom-menu__item" to="/auth">
                <span class="bottom-menu__icon-wrap"><svg class="svg-icon-enter2 svg-icon" width="24" height="26"><use xlink:href="#enter2"></use></svg></span>
                Вход
            </router-link>
            <div v-else-if="user.id > 0" class="bottom-menu__item red" @click="logout" href="javascript:;">
                <span class="bottom-menu__icon-wrap">
                    <svg class="svg-icon-exit svg-icon" width="20" height="20"><use xlink:href="#exit"></use></svg>
                </span>
                Выход
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        props: ['instance'],
        name: 'Main',
        data: function(){
            return {
                basketSum:'',
                orderCount:'',

                loading:false,
                loadingMessage:'',
            };
        },
        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
            orderCount: function () {
                return this.$store.getters.getOrderCount;
            },
            basketCount: function () {
                return this.$store.getters.getBasketCount;
            },
        },
        created() {

            let $this = this;

            /*$this.updateCountMenu();

            document.addEventListener("resume", function () {
                console.log("reopen");
                $this.requestCount = "1";
                $this.updateCountMenu();
            }, false);

            console.log("created 1");


            window.addEventListener('onMessageReceived', (evt) => {

                if(evt.detail.pushType == 'NewRequest'){
                    console.log(evt.detail);
                    console.log("onMessageReceived 1");
                    $this.requestCount = evt.detail.requestCount;
                }


            });*/



        },

        mounted:function () {
            this.$root.pageClass = "";
        },

        methods:{
            logout: function(){
                let vm = this;
                vm.$store.dispatch("logout").then(function(){
                    vm.$store.dispatch("fetchStart").then(function(){
                        vm.$router.push('/');
                    });
                });
            },
            updateCountMenu: function () {

                let $this = this;

                $this.instance.get(
                    '/lk/getCountMenu',
                ).then(function (response) {
                    if(response.data.status == 'error'){
                        console.log(response);
                        let errors = '';
                        response.data.errors.forEach(function (item) {
                            errors += item.message
                        });
                        alert(JSON.stringify(errors));
                    }else{
                        $this.requestCount = response.data.data.countRequests;
                    }
                });
            },

        },
        components: {}
    }
</script>